export const Overline = ({ children, className = "", ...props }) => (
  <p
    className={`text-xs sm:text-sm uppercase tracking-[0.25em] font-medium text-[#5fa292] ${className}`}
    {...props}
  >
    {children}
  </p>
);
